module.exports = __webpack_public_path__ + "static/media/multi-power-vitality-for-her-img.d6710095.png";